// Longitudes máximas de los campos de fin de pedido.
// Se usa el menor tamaño entre la columna MySQL (WebPedidos) y la de LIBRA.
export const LONG_PEDIDO = {
  persona_pedido: 40,
  pedido_cliente: 100,
  reservado_alfa_3: 100,
  observaciones: 500,
  nombre_dom_envio: 50,
  direccion_dom_envio: 50,
  localidad_dom_envio: 50,
  cod_postal_dom_envio: 15,
}

// Devuelve el primer campo del pedido que supera su longitud máxima, o null
export const campoExcedeLongitud = pedido =>
  Object.keys(LONG_PEDIDO).find(
    campo => String(pedido?.[campo] ?? '').length > LONG_PEDIDO[campo],
  ) ?? null
